import { Tooltip, makeStyles } from '@material-ui/core';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { RateOptionPriceDisclaimerTooltipText, BrochuresRateOptionPriceDisclaimerTooltipText, BrochuresRateOptionTotalPriceDisclaimerTooltipText } from '../../../constants';
import { checkIsLoggedIn } from '../../../store/slices/user';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontFamily: 'var(--fontFamilyBody)',
  },
}));

const RateOptionPriceDisclaimerTooltip = ({ rate, decimalScale, isTotalAmount }) => {
  const classes = useStyles();
  const { isViewingBrochure } = useSelector((state) => state.brochure);
  const { isViewingCompare } = useSelector((state) => state.compare);
  const isLoggedIn = useSelector(checkIsLoggedIn);

  let tooltipText = isLoggedIn || !isViewingBrochure || !isViewingCompare
    ? RateOptionPriceDisclaimerTooltipText : BrochuresRateOptionPriceDisclaimerTooltipText;

  if (isTotalAmount) {
    tooltipText = BrochuresRateOptionTotalPriceDisclaimerTooltipText;
  }
  return (
    <Tooltip title={tooltipText} arrow classes={classes}>
      <NumberFormat value={rate} prefix="$" displayType="text" thousandSeparator fixedDecimalScale="true" decimalScale={decimalScale} />
    </Tooltip>
  );
};

RateOptionPriceDisclaimerTooltip.propTypes = {
  rate: PropTypes.number.isRequired,
  decimalScale: PropTypes.number,
  isTotalAmount: PropTypes.bool,
};

RateOptionPriceDisclaimerTooltip.defaultProps = {
  decimalScale: 2,
  isTotalAmount: false,
};

export default RateOptionPriceDisclaimerTooltip;
